import React from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';

export function readSidebarSectionExpanded(storageKey, defaultExpanded = false) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw === '0' || raw === 'false') return false;
    if (raw === '1' || raw === 'true') return true;
  } catch {
    /* ignore */
  }
  return defaultExpanded;
}

export function writeSidebarSectionExpanded(storageKey, expanded) {
  try {
    localStorage.setItem(storageKey, expanded ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export default function StorageBoxSidebarSection({ title, expanded, onToggle, children, className = '' }) {
  return (
    <section className={['sb-drive-sidebar-section', className].filter(Boolean).join(' ')}>
      <button
        type="button"
        className="sb-drive-sidebar-section__head"
        onClick={onToggle}
        aria-expanded={expanded}
      >
        {expanded ? <FiChevronDown aria-hidden /> : <FiChevronRight aria-hidden />}
        <span className="sb-drive-sidebar-section__title">{title}</span>
      </button>
      {expanded ? <div className="sb-drive-sidebar-section__body">{children}</div> : null}
    </section>
  );
}
